module.exports = __webpack_public_path__ + "img/ingredienten-spinazieschotel-met-tomaten-en-rijst.09467a7c.jpg";